export default __webpack_public_path__ + "static/policy5-c61faa6f2848ece8050ddec64cfff2c7.png";